// = =======================================
// ACTIVITY SELECTORS
// = =======================================
export const formatActivity = (item = {}) => ({
  ...item
});

export const formatActivities = (list = []) => list.map(item => formatActivity(item));

export const formatActivityList = (list = {}) => {
  const results = list.results || [];
  const count = list.count || 0;

  const formattedResults = results.map(item => formatActivity(item));
  return {
    ...list,
    results: formattedResults,
    count
  };
};
